module.exports = __webpack_public_path__ + "teqbahn-assets/media/gi2.411ed34c.png";